<app-page-header title="Product Management" subtitle="Manage product categories and product definitions">
    <div actions>
        <p-button
            label="Export Report"
            (click)="exportXlsx()"
            severity="secondary"
            variant="outlined"
            class="p-button-outlined mr-2"
        ></p-button>
        <p-button label="Add New" (click)="openDialog('add')" class="p-button-success"></p-button>
    </div>
</app-page-header>
<div class="table-card">
    <p-table
        #dt
        [value]="products"
        [columns]="cols"
        [loading]="loading"
        [paginator]="true"
        [rows]="10"
        [scrollable]="true"
        scrollHeight="flex"
        dataKey="id"
        [rowHover]="true"
        [globalFilterFields]="['categoryName', 'productName']"
    >
        <ng-template #header let-columns>
            <tr>
                <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                    <div class="flex items-center gap-2 text-left">
                        {{ col.header }}
                        <p-sortIcon [field]="col.field"></p-sortIcon>
                        <app-column-filter [table]="dt" type="text" [field]="col.field" display="menu"></app-column-filter>
                    </div>
                </th>
                <th></th>
            </tr>
        </ng-template>
        <ng-template #body let-product>
            <tr>
                <td>{{ product.categoryName }}</td>
                <td>{{ product.productName }}</td>
                <td>
                    <p-button
                        severity="secondary"
                        label="Edit"
                        icon="pi pi-pencil"
                        variant="outlined"
                        (click)="openDialog('edit', product)"
                        class="p-button-text"
                    >
                    </p-button>
                </td>
            </tr>
        </ng-template>
    </p-table>

    <p-dialog [(visible)]="displayDialog" [modal]="true" [header]="dialogHeader" [closable]="true" [style]="{ width: '400px' }">
        <div class="p-fluid">
            <div class="p-field">
                <p-select
                    [options]="categories"
                    appendTo="body"
                    [(ngModel)]="formData.categoryId"
                    optionLabel="name"
                    optionValue="id"
                    autocomplete="off"
                    placeholder="Product Category"
                    class="flex-auto w-full"
                />
            </div>
            <div class="p-field">
                <input
                    [(ngModel)]="formData.productName"
                    class="flex-auto w-full mt-2"
                    autocomplete="off"
                    pInputText
                    [placeholder]="'Product Name'"
                />
            </div>
        </div>

        <ng-template pTemplate="footer">
            <div class="flex justify-between w-full">
                <p-button label="Cancel" [text]="true" severity="secondary" (click)="hideDialog()"></p-button>
                <p-button [label]="dialogMode === 'add' ? 'Add New' : 'Save'" (click)="save()"></p-button>
            </div>
        </ng-template>
    </p-dialog>
</div>
